import useStorageControllerState from './useStorageControllerState'

export default useStorageControllerState
